export default __webpack_public_path__ + "static/media/agreement.46d47851.pdf";